import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { COLOR } from '@src/styles/color';

export const StyledPlaceholder = styled(Typography)`
  color: ${COLOR.text.placeholder};
  font-style: italic;
  font-size: 14px;
`;
